export default __webpack_public_path__ + "static/media/spacecraft.6a96ba0a.png";